export default "__VITE_ASSET__BN$EN8gU__"